import * as React from "react";
import { SpinnerWrapper, Table } from "soprasteria-ui-library";
import { IImportedXmlSummary } from "../../../models/IImportedXml";
import { dateTimeToDateString } from "../../../helpers/DateHelper";
import { IMPORTED_XMLS } from "../../../utils/RouteConstants";
import { Link } from "react-router-dom";


interface IImportedXmlsTable {
    data: IImportedXmlSummary[];
    isFetchingXmls: boolean;
    selectedCareProviderId?: number;
    canViewImportXmlAsCareProvider: boolean;
}

export const ImportedXmlsTable: React.FunctionComponent<IImportedXmlsTable> = ({ data, isFetchingXmls, selectedCareProviderId, canViewImportXmlAsCareProvider }) => {

    const renderTableLink = (linkText?: string, importedXmlId?: number) => {
        var url = canViewImportXmlAsCareProvider && selectedCareProviderId 
            ? `${IMPORTED_XMLS}/${importedXmlId}/${selectedCareProviderId}` 
            : `${IMPORTED_XMLS}/${importedXmlId}`;
        return <Link to={url}>{linkText}</Link>
    }

    return (
        <>
            <SpinnerWrapper isLoading={isFetchingXmls}>
                <Table>
                    <thead>
                        <tr>
                            <th style={{ width: "8%" }}>Datum</th>
                            <th>Filnamn</th>
                            <th>Filtyp</th>
                            <th style={{ width: "12%" }}>Antal ärenden</th>
                            <th style={{ width: "8%" }}>Loggade fel</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.length > 0 ?
                                <>
                                    {
                                        data.map((xml, key) =>
                                            <tr key={key} className="clickable-row">
                                                <td className="table-data-link">{renderTableLink(dateTimeToDateString(xml.importedDate), xml.importedXmlId)}</td>
                                                <td className="table-data-link">{renderTableLink(xml.fileName, xml.importedXmlId)}</td>
                                                <td className="table-data-link">{renderTableLink(xml.importedXmlType, xml.importedXmlId)}</td>
                                                <td className="table-data-link">{renderTableLink(xml.numberOfRows.toString(), xml.importedXmlId)}</td>
                                                <td className="table-data-link">{renderTableLink(xml.numberOfRowsWithErrors.toString(), xml.importedXmlId)}</td>
                                            </tr>
                                        )
                                    }
                                </>
                                : <tr><td colSpan={5}>Det finns inga filer att visa</td></tr>
                        }
                    </tbody>
                </Table>
            </SpinnerWrapper>
        </>
    )
}